module.exports = __webpack_public_path__ + "static/media/oak-not-selected.c0e32a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tags/oak-not-selected.svg
// module id = 66
// module chunks = 0